import { RefreshCwIcon } from 'lucide-react';
import { useState } from 'react';

import { Button } from '@/components/core/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/core/tooltip';
import { cn } from '@/shared/helpers';

type Props = {
  onRefresh: () => Promise<any>;
  isLive?: boolean;
  onChangeLive?: (value: boolean) => void;
};

export function DataTableRefreshMenu({ onRefresh, isLive, onChangeLive }: Props) {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const refresh = async () => {
    setIsRefreshing(true);
    try {
      await onRefresh();
    } finally {
      setIsRefreshing(false);
    }
  };

  return (
    <div data-slot="refresh" className="flex items-center gap-2">
      {onChangeLive && (
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="outline"
              size="icon"
              onClick={() => onChangeLive(!isLive)}
              aria-label={`Turn ${isLive ? 'off' : 'on'} live updates`}
            >
              <span
                className={cn(
                  'absolute size-3 animate-ping rounded-full bg-primary opacity-25 animation-duration-[2s]',
                  isLive ? 'inline-flex' : 'hidden',
                )}
              />
              <span
                className={cn(
                  isLive ? 'bg-primary/80' : 'bg-foreground/50',
                  'relative inline-flex size-2.5 rounded-full',
                )}
              />
            </Button>
          </TooltipTrigger>
          <TooltipContent>Turn {isLive ? 'off' : 'on'} live updates</TooltipContent>
        </Tooltip>
      )}
      <Button
        variant="outline"
        size="icon"
        loading={isRefreshing}
        onClick={refresh}
        aria-label="Refresh table"
      >
        <RefreshCwIcon />
      </Button>
    </div>
  );
}
